import React, { useState } from 'react';

interface TestFlightFiltersProps {
  onStatusFilter: (status: string) => void;
  onGroupFilter: (group: string) => void;
  onSearch: (searchTerm: string) => void;
  groups: string[];
  filteredCount: number;
  totalCount: number;
}

const TestFlightFilters: React.FC<TestFlightFiltersProps> = ({
  onStatusFilter,
  onGroupFilter,
  onSearch,
  groups,
  filteredCount,
  totalCount
}) => {
  const [statusFilter, setStatusFilter] = useState('');
  const [groupFilter, setGroupFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setStatusFilter(value);
    onStatusFilter(value);
  };

  const handleGroupChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setGroupFilter(value);
    onGroupFilter(value);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  return (
    <div className="filter-controls mb-4">
      <h5>🔍 Filter & Search</h5>
      <div className="filter-row">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search testers..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="form-input"
          />
          <span className="search-icon">🔍</span>
        </div>
        
        <select
          value={statusFilter}
          onChange={handleStatusChange}
          className="form-select"
        >
          <option value="">All Statuses</option>
          <option value="INVITED">Invited</option>
          <option value="INSTALLED">Installed</option>
          <option value="NO_RESPONSE">No Response</option>
          <option value="BETA_APPROVED">Beta Approved</option>
          <option value="BETA_REJECTED">Beta Rejected</option>
        </select>
        
        <select
          value={groupFilter}
          onChange={handleGroupChange}
          className="form-select"
        >
          <option value="">All Groups</option>
          {groups.map(group => (
            <option key={group} value={group}>
              {group}
            </option>
          ))}
        </select>
      </div>
      
      <div className="filter-info">
        <span>Showing {filteredCount} of {totalCount} testers</span>
      </div>
    </div>
  );
};

export default TestFlightFilters;
